import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { EmbeddedCustomerTypes } from '../helpers/constants'
import { ConfirmCustomerData } from '../helpers/types'
import { AddCustomerActions } from './AddCustomerActions'
import { ConfirmDetailsDataRow } from './ConfirmDetailsDataRow'

export interface AddCustomerConfirmDetailsProps {
  customerData: ConfirmCustomerData
  onCancel: () => void
}

export const AddCustomerConfirmDetails = ({
  customerData,
  onCancel,
}: AddCustomerConfirmDetailsProps) => {
  const { t } = useTranslation()

  const customerType = customerData?.business
    ? EmbeddedCustomerTypes.BUSINESS
    : EmbeddedCustomerTypes.INDIVIDUAL

  const { data, displayData } =
    (customerType === EmbeddedCustomerTypes.BUSINESS
      ? customerData?.business
      : customerData?.individual) || {}

  const onConfirmDetails = () => {
    // TODO: handle submit request
  }

  return (
    <>
      <Box padding={16} hasBorder borderRadius={4} background="standard">
        <ConfirmDetailsDataRow
          label={t('type')}
          data={t(`embeddedCustomers.type.${customerType}`)}
        />
        {Object.keys(data)?.map(key => (
          <ConfirmDetailsDataRow
            key={key}
            label={t(`embeddedCustomers.businessForm.${key}`)}
            data={displayData?.[key] ?? data?.[key]}
          />
        ))}
      </Box>
      <AddCustomerActions onCancel={onCancel} onConfirmDetails={onConfirmDetails} />
    </>
  )
}
